@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.attachmentDropdown {
  padding: 8px 12px;
  max-height: 250px;
  overflow-y: auto;
  @include custom-scroll-minimal;

  @include respond-to('max-sm') {
    width: 250px;
    min-width: 250px;
  }
}

.attachmentButton {
  gap: 8px;
  padding-right: 8px;
  @include border-radius-r2;
}

.infoWrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pillLabel {
  @include typography-v2-body-sm;
}
